import { useCallback } from "react";
import { useMutation } from "urql";

import { FileReportType } from "../../components/graphql/schema.graphql";
import { DEFAULT_SNACKBAR_ERROR_MESSAGE } from "../../constants/strings";
import { ReportFile } from "../../features/files/queries.graphql";
import useShowSnackbar from "../useShowSnackbar";
import { useUrqlResponseHandler } from "../useUrqlResponseHandler";

export const useReportFiles = () => {
  const { showSuccess, showError } = useShowSnackbar();
  const [result, reportFile] = useMutation(ReportFile);
  const { getResponseFromState } = useUrqlResponseHandler();

  const reportFiles = useCallback(
    async (fileIds: string[], fileReportType: FileReportType) => {
      if (fileIds.length === 1) {
        const fileId = fileIds[0];

        try {
          const result = await reportFile({
            input: { fileId, type: fileReportType },
          });

          getResponseFromState({
            state: result,
            successMessage: "File reported successfully.",
            errorMessage: DEFAULT_SNACKBAR_ERROR_MESSAGE,
          });
        } catch (error) {
          console.error("Error reporting file:", error);
          showError(DEFAULT_SNACKBAR_ERROR_MESSAGE);
        }
      } else {
        let nbOfSuccess = 0;

        await Promise.all(
          fileIds.map(async (fileId) => {
            try {
              const result = await reportFile({
                input: { fileId, type: fileReportType },
              });

              getResponseFromState({
                state: result,
              });

              if (!result.error) {
                nbOfSuccess++;
              }
            } catch (error) {
              console.error("Error reporting file:", error);
            }
          }),
        );

        if (nbOfSuccess === fileIds.length) {
          showSuccess("All files reported successfully.");
        } else {
          showError(DEFAULT_SNACKBAR_ERROR_MESSAGE);
        }
      }
    },
    [getResponseFromState, showSuccess, showError, reportFile],
  );

  return { reportFiles, result };
};
